import CalculationMethod from "./CalculationMethod";

export default CalculationMethod;